import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Calendar } from 'lucide-react';
import { toast } from 'sonner';
import { employeeAPI } from '@/lib/api';

export default function EmployeeAvailabilityDialog({ employee }) {
  const [open, setOpen] = useState(false);
  const [formData, setFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    available_hours: employee.daily_hours,
    notes: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {
      await employeeAPI.setAvailability({
        employee_id: employee.id,
        ...formData,
        available_hours: parseFloat(formData.available_hours)
      });
      
      toast.success('Availability updated successfully');
      setOpen(false);
      setFormData({
        date: new Date().toISOString().split('T')[0],
        available_hours: employee.daily_hours,
        notes: ''
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Failed to update availability');
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button size="sm" variant="outline" className="gap-2">
          <Calendar className="h-4 w-4" />
          Adjust Hours
        </Button>
      </DialogTrigger>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Adjust Available Hours - {employee.name}</DialogTitle>
          <DialogDescription>
            Set custom hours for specific dates (time off, holidays, reduced schedule)
          </DialogDescription>
        </DialogHeader>
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
          <div>
            <Label htmlFor="date">Date</Label>
            <Input
              id="date"
              type="date"
              value={formData.date}
              onChange={(e) => setFormData({ ...formData, date: e.target.value })}
              required
            />
          </div>

          <div>
            <Label htmlFor="available_hours">Available Hours</Label>
            <Input
              id="available_hours"
              type="number"
              step="0.5"
              min="0"
              max="24"
              value={formData.available_hours}
              onChange={(e) => setFormData({ ...formData, available_hours: e.target.value })}
              required
            />
            <p className="text-xs text-muted-foreground mt-1">
              Default: {employee.daily_hours} hours. Set to 0 for time off.
            </p>
          </div>

          <div>
            <Label htmlFor="notes">Notes (optional)</Label>
            <Input
              id="notes"
              value={formData.notes}
              onChange={(e) => setFormData({ ...formData, notes: e.target.value })}
              placeholder="Vacation, Half day, Holiday..."
            />
          </div>

          <div className="flex gap-2 pt-2">
            <Button type="submit" className="flex-1">
              Save
            </Button>
            <Button type="button" variant="outline" onClick={() => setOpen(false)}>
              Cancel
            </Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
}
